<app-sidenav>
  <ng-template #sidenavContent>
    <app-card title="{{ 'content.this-order' | translate }}">
      @if (consumerRequestReport) {
        <div>
          <div>{{ 'content.subject' | translate }}:
            @for (consumer of this.consumerReport?.consumers || []; track consumer) {
              <div>{{ primaryGivenNames(consumer) }} {{ primaryName(consumer).lastName }}</div>
            }
          </div>
          <div>{{ 'content.product' | translate }}: {{ consumerReport.tracking.productRequested }}</div>
          <div>{{ 'content.language' | translate }}: {{ consumerReport.tracking.reportLanguage }}</div>
          <div>{{ 'content.reference-id' | translate }}: {{ consumerReport.tracking.userRefernce.trim() }}</div>
          <div>{{ 'content.branch' | translate }}: {{ consumerReport.tracking.memberCode }}</div>
          <div>{{ 'content.results-issued' | translate }}: {{ reformatDate(consumerReport.tracking.resultsIssuedDate, "LLL", "DDMMYYYY")}}</div>
        </div>
      }
    </app-card>
  </ng-template>
  <ng-template #mainContent>
    @if (creditReport) {
      <app-pdf-button-bar newOrderUrl="/consumer-services" [css]="ifsReportCss" [documentRootElement]="creditReport"></app-pdf-button-bar>
    }
    <p>{{ 'content.results-displayed-below' | translate }}</p>
    <h1>{{ 'content.mobile-directory-services' | translate }}</h1>
    @for (consumer of this.consumerReport?.consumers || []; track consumer) {
      <div #creditReport class="mds-report">
        <div>
          <div class="row">
            <h2>{{ 'content.inquiry' | translate }}</h2>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.person.name' | translate }}:</div>
            <div class="col-9">{{ primaryGivenNames(consumer) }}</div>
          </div>
          @for (a of addresses(consumer); track a) {
            <div>
              <div class="row">
                <div class="col-3">{{ 'content.address.address' | translate }}:</div>
                <div class="col-9">{{ a.aptUnit }} {{ a.streetName }}</div>
              </div>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-9">{{ a.city }}, {{ a.province }}, {{ a.postal }}</div>
              </div>
            </div>
          }
          <div class="row">
            <div class="col-3">{{ 'content.telephone' | translate }}:</div>
            <div class="col-9">{{ reformatPhone(primaryPhone(consumer)) }}</div>
          </div>
        </div>
        <div class="mds-inquiry">
          <div class="row">
            <h2>{{ 'content.mobile-directory-search-inquiry-section' | translate }}</h2>
          </div>
          <div class="row">
            <div class="col-12">{{ 'content.identity-verification' | translate }}</div>
          </div>
          <div class="row">
            <div class="col-12">{{ 'content.response-code' | translate }}: {{ 'content.keyed.mds.status-code.' + consumer?.dx09?.dx01?.responseCode | translate }}</div>
          </div>
          <div class="row">
            <div class="col-12">{{ 'content.summary-score' | translate }}: {{ consumer?.dx09?.dx01?.summaryScore }}</div>
          </div>
          <br/>
          <div class="row">
            <div class="col-3">{{ 'content.person.last-name' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.lastName }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.person.first-name' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.firstName }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.person.middle-name' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.middleName }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.person.dob' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.dateOfBirth }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.civic-number' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.civicNumber }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.street-name' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.streetName }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.unit-number' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.unitNumber }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.city' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.city }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.province' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.province }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.postal-code' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.postalCode }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.address.country' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx01?.country }}</div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-3">{{ 'content.account-status' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx02?.accountStatus }}</div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-3">{{ 'content.account-type' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx03?.accountType }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.account-class' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx03?.accountClass }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.account-user' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx03?.accountUser }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.carrier-name' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx03?.carrierName }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.preferred-lang' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx03?.prefferedLanguage }}</div>
          </div>
          <div class="row">
            <div class="col-3">{{ 'content.brand-name' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx03?.brandName }}</div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-3">{{ 'content.activation-date' | translate }}</div>
            <div class="col-9">{{ consumer?.dx09?.dx07?.activationDate }}</div>
          </div>
          <hr/>
          @if (consumer?.dx09?.dx04) {
            <div class="mds-inquiry">
              <div class="row">
                <div class="col-3">{{ 'content.accuracy-m' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx04.accuracy }}</div>
              </div>
              <div class="row">
                <div class="col-3">{{ 'content.latitude' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx04.latitude }}</div>
              </div>
              <div class="row">
                <div class="col-3">{{ 'content.longitude' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx04.longitude }}</div>
              </div>
              <div class="row">
                <div class="col-3">{{ 'content.location-timestamp' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx04.locationTimestamp }}</div>
              </div>
            </div>
          }
          @if (consumer?.dx09?.dx05) {
            <div class="mds-inquiry">
              <div class="row">
                <div class="col-3">{{ 'content.location' | translate }}</div>
                <div class="col-9"></div>
              </div>
              <div class="row">
                <div class="col-3">{{ 'content.address.city' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx05.city }}</div>
              </div>
              <div class="row">
                <div class="col-3">{{ 'content.address.province-short' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx05.province }}</div>
              </div>
              <div class="row">
                <div class="col-3">{{ 'content.location-timestamp' | translate }}</div>
                <div class="col-9">{{ consumer.dx09.dx05.locationTimestamp }}</div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </ng-template>
</app-sidenav>
